import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft, Layers } from "lucide-react";
import { API_URL } from "../config";
import { LectureCard } from "./Lectures";
import { plural } from "./SeriesStrip";

/** Страница серии: описание и все её материалы в заданном порядке. */
export default function SeriesPage() {
  const { id } = useParams();
  const [series, setSeries] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setSeries(null);
    setNotFound(false);
    fetch(`${API_URL}/series/${id}`)
      .then(r => { if (!r.ok) throw new Error(); return r.json(); })
      .then(setSeries)
      .catch(() => setNotFound(true));
  }, [id]);

  if (notFound) {
    return (
      <section>
        <p style={{ color: "#888" }}>Подборка не найдена.</p>
        <Link to="/lectures">← К материалам</Link>
      </section>
    );
  }
  if (!series) return <section><p style={{ color: "#888" }}>Загрузка…</p></section>;

  return (
    <section>
      <Helmet>
        <title>{series.title} — Современный Врач</title>
        {series.description && <meta name="description" content={series.description} />}
      </Helmet>
      <Link to="/lectures" className="series-back"><ArrowLeft size={14} strokeWidth={2.2} /> Все материалы</Link>
      <div className="series-header">
        <span className="series-header-icon"><Layers size={22} strokeWidth={2.2} /></span>
        <div>
          <h2 className="series-header-title">{series.title}</h2>
          <div className="series-header-count">{series.count} {plural(series.count)}</div>
        </div>
      </div>
      {series.description && <p className="series-description">{series.description}</p>}
      {series.items.map(l => <LectureCard key={l.id} l={l} />)}
    </section>
  );
}
